
<div class="md:w-368 mx-auto">
  <JobPostScheduleCard
    id="schedule-type-one-time"
    title="One-time sitter"
    body="Date night, upcoming event, backup"
    :shadow="false"
    class="mb-16"
  >
    <OneTimeScheduleIcon />
  </JobPostScheduleCard>

  <Card :clickable="false" class="w-full md:p-24">
    <form>
      <div class="mb-32">
        <poppins-date-picker
          id="one-time-schedule-datepicker"
          v-model="startDate"
          labelName="Start date"
          :minDate="minStartDate"
          :maxDate="maxStartDate"
          :status="datepickerStatus"
          :helperText="errors.startDate"
          class="mb-16 w-full"
          @input="$delete(errors, 'startDate')"
        />
        <poppins-time-picker
          id="one-time-schedule-start"
          v-model="startTime"
          class="mb-16"
          labelName="Start time"
          :start="startRange[0]"
          :end="startRange[1]"
          :status="startTimeStatus"
          :helperText="errors.startTime"
          @input="$delete(errors, 'startTime')"
        />
        <poppins-time-picker
          id="one-time-schedule-end"
          v-model="endTime"
          class="mb-16"
          labelName="End time"
          :start="endRange[0]"
          :end="endRange[1]"
          :status="endTimeStatus"
          :helperText="errors.endTime"
          @input="$delete(errors, 'endTime')"
        />
        <Checkbox v-model="startTimeFlexible" labelName="Start time is flexible" checkboxId="start-time-flexible" />
        <div>
          <p>Duration: {{ duration }}</p>
        </div>
      </div>
      <div class="flex flex-row-reverse">
        <RouteStepperNextButton
          :stepData="reviewSection"
          :draftData="draftData"
          :validate="validate"
          @errors="errors = $event"
        />
      </div>
    </form>
  </Card>
</div>
